import { render, staticRenderFns } from "./SeparatorImagesTwo.vue?vue&type=template&id=406b9787&"
import script from "./SeparatorImagesTwo.vue?vue&type=script&lang=js&"
export * from "./SeparatorImagesTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports